import React, {useEffect} from "react";
import './StronaGlowna.css';
import {Link} from "react-router-dom";

export default function StronaGlowna(){

    useEffect(()=>{
        document.title="MatmaGO";
    },[])

    return(

      <div className="glowna-container">

          <div className='margin_top'></div>

          <h1>MatmaGO</h1>

          <p>Strona internetowa na konkurs "Zobaczyć matematykę"</p>

          <div className="glowna-btns" >


                  <Link to='/analiza'>
                      <button  className="btns" id="buttonik">
                  START
                      </button>
                  </Link>

          </div>

      </div>
    );
}